module.exports = __webpack_public_path__ + "img/james-harden-walk-away.b59c1a97.gif";